import React from "react"
import styled from "styled-components"
import { useSlideHeight } from "./SlideHeightContext"

const DummyElementForHeight = styled.div`
  height: ${props => (props.height > 0 ? `${props.height}px` : `80vh`)};
  transition: 0.5s;
`

export function SlideHeightDummyElement() {
  const { slideHeight } = useSlideHeight()

  return <DummyElementForHeight height={slideHeight} />
}
